module.exports = __webpack_public_path__ + "static/img/首页_1.7d52d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/首页_1.png
// module id = XU+5
// module chunks = 0